import gsap from "gsap";

export function pageTransition() {
  const overlay = document.getElementById("transition-overlay");
  const mainContent = document.querySelector("main");

  if (!overlay || !mainContent) {
    return;
  }

  // link selector
  const links = document.querySelectorAll(
    'a[href^="/"]:not([target="_blank"]), a[href^="' +
      window.location.origin +
      '"]:not([target="_blank"])'
  );

  function animatePageIn() {
    // Immediately SET the content to visible
    gsap.set(mainContent, { visibility: "visible" });

    // Animate the overlay away AND fade in the content simultaneously
    gsap
      .timeline({ defaults: { ease: "power2.inOut" } })
      .to(overlay, {
        duration: 0.8,
        y: "100%",
      })
      .to(
        mainContent,
        {
          duration: 0.8,
          opacity: 1,
        },
        "<" // The '<' symbol runs this animation at the same time as the previous one
      );
  }

  function animatePageOut(href) {
    // Start with the overlay at the top, off-screen
    gsap.set(overlay, {
      y: "-100%",
      borderBottomLeftRadius: "100% 30%",
      borderBottomRightRadius: "100% 30%",
    });

    // Animate it down to cover the screen
    gsap.to(overlay, {
      duration: 0.8,
      y: "0%",
      ease: "power2.inOut",
      borderBottomLeftRadius: "0% 0%",
      borderBottomRightRadius: "0% 0%",
    });

    // Start navigation shortly after the animation begins.
    setTimeout(() => {
      window.location.href = href;
    }, 200);
  }

  // Run the IN animation when the page loads
  animatePageIn();

  // Add click listeners
  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      // Add a check to avoid transitioning to the same page.
      if (link.href === window.location.href) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      const destination = link.getAttribute("href");
      animatePageOut(destination);
    });
  });
}
